/**
 * LoadingSkeleton.tsx — shimmering placeholder rows.
 *
 * Used while the Bank Submission Status table is fetching. Width is
 * configurable so the caller can match the target column.
 */
import React from 'react';

export function SkeletonLine({ width = '100%', height = 14 }: { width?: number | string; height?: number }) {
	return <span className="skel" style={{ width, height, display: 'inline-block' }} aria-hidden="true" />;
}

export default function LoadingSkeleton({
	rows = 6,
	columns = 8,
}: {
	rows?: number;
	columns?: number;
}) {
	const widths = ['80%', '60%', '70%', '50%', '90%', '40%', '65%', '55%'];
	return (
		<div role="status" aria-live="polite" aria-busy="true">
			<span className="visually-hidden" style={{ position: 'absolute', left: -9999 }}>
				Loading…
			</span>
			<table className="tbl" style={{ width: '100%' }}>
				<tbody>
					{Array.from({ length: rows }).map((_, r) => (
						<tr key={r}>
							{Array.from({ length: columns }).map((__, c) => (
								<td key={c} style={{ padding: '12px' }}>
									<SkeletonLine width={widths[c % widths.length]} />
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
